import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import { Approval, Cancel } from "@mui/icons-material";


const PurchaseActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess,
    selectedMode, approvalStatus }) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);
    };
    return (

        <Grid container display="flex-start" padding={0}>

            {/* Add Button */}
            {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} /> */}
            {/* <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Back to menu">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('edit')}  >
                            <ModeEditOutlineOutlinedIcon style={{ fontSize:"18px" ,color: selectedButton === 'edit' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Edit</Typography>
                        </IconButton>                       
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
            {/* Add Button */}
            <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Send Mail">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Email')}>
                            <EmailOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Send Mail</Typography>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="PDF/Print">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('PDF')}>
                            <PictureAsPdfOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>PDF/Print</Typography>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid>

               {selectedMode !== 1 && approvalStatus === "PENDING" && (
                <>
                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                 
                 

                    {/* Add Button */}
                    <Grid item md={0} ml="5px" mr="5px">

                        <Tooltip title="Approve PO">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('Approve')}>
                                    <Approval style={{ fontSize: "18px", color: selectedButton === 'Approve' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Approve</Typography>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                    {/* Add Button */}
                    <Grid item md={0} ml="5px" mr="5px">

                        <Tooltip title="Cancel PO">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('Cancel')}>
                                    <Cancel style={{ fontSize: "18px", color: selectedButton === 'Cancel' ? "yellow" : "#e76b6b" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Cancel</Typography>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Grid>
                </>
            )}
            {selectedMode === 1 && (<>
                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                {/* Add Button */}
                <Grid item md={0} ml="5px" mr="5px">
                    <Tooltip title="Receive">
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <IconButton onClick={() => handleButtonClick('Receive')}>
                                <ExitToAppRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'Receive' ? "yellow" : "#009688" }} />
                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Receive</Typography>
                            </IconButton>

                        </div>
                    </Tooltip>
                </Grid>
            </>)}
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Convert to Bill">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Bill')}>
                            <ReceiptRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'Bundles' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Convert to Bill</Typography>
                        </IconButton>
                        
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Timeline">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('timeline')}>
                            <ReceiptRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'timeline' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Timeline</Typography>
                        </IconButton>                       
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />           */}


         

        </Grid>



    )
};
export default PurchaseActionMenu;



// import {
//   Box,
//   Divider,
//   Grid,
//   IconButton,
//   Tooltip,
//   Typography,
//   Paper,
//   alpha
// } from "@mui/material";
// import React, { useState } from "react";

// import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
// import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
// import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
// import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
// import TimelineIcon from '@mui/icons-material/Timeline';

// const PurchaseActionMenu = ({
//   selectedButtonName,
//   setSelectedButtonName,
//   handlecallProcess,
//   selectedMode,
//   colors // Add colors prop for theming
// }) => {
//   const [selectedButton, setSelectedButton] = useState(null);

//   const actionButtons = [
//     {
//       key: 'edit',
//       label: 'Edit',
//       icon: <ModeEditOutlineOutlinedIcon />,
//       tooltip: 'Back to menu'
//     },
//     {
//       key: 'Email',
//       label: 'Send Mail',
//       icon: <EmailOutlinedIcon />,
//       tooltip: 'Send Mail'
//     },
//     {
//       key: 'PDF',
//       label: 'PDF/Print',
//       icon: <PictureAsPdfOutlinedIcon />,
//       tooltip: 'PDF/Print'
//     },
//     ...(selectedMode === 1 ? [{
//       key: 'Receive',
//       label: 'Receive',
//       icon: <ExitToAppRoundedIcon />,
//       tooltip: 'Receive'
//     }] : []),
//     {
//       key: 'Bill',
//       label: 'Convert to Bill',
//       icon: <ReceiptRoundedIcon />,
//       tooltip: 'Convert to Bill'
//     },
//     {
//       key: 'timeline',
//       label: 'Timeline',
//       icon: <TimelineIcon />,
//       tooltip: 'Timeline'
//     }
//   ];

//   const handleButtonClick = (buttonName) => {
//     setSelectedButton(buttonName);
//     setSelectedButtonName(buttonName);
//     handlecallProcess(buttonName);
//   };

//   const getButtonStyle = (key, isSelected) => ({
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     p: 1.5,
//     borderRadius: 2,
//     transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
//     backgroundColor: isSelected
//       ? alpha(colors?.primary?.[500] || '#009688', 0.12)
//       : 'transparent',
//     border: `1px solid ${alpha(colors?.primary?.[500] || '#009688', isSelected ? 0.3 : 0.1)}`,
//     '&:hover': {
//       backgroundColor: alpha(colors?.primary?.[500] || '#009688', 0.08),
//       transform: 'translateY(-2px)',
//       boxShadow: `0 8px 25px ${alpha(colors?.primary?.[500] || '#009688', 0.15)}`
//     },
//     minWidth: 80
//   });

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 1.5,
//         borderRadius: 3,
//         border: `1px solid ${alpha(colors?.grey?.[300] || '#e0e0e0', 0.5)}`,
//         backdropFilter: 'blur(12px)',
//         background: `linear-gradient(145deg, ${alpha(colors?.grey?.[50] || '#f8f9fa', 0.8)} 0%, transparent 100%)`,
//         display: 'flex',
//         alignItems: 'center',
//         gap: 0.5,
//         flexWrap: 'nowrap',
//         overflow: 'hidden'
//       }}
//     >
//       {actionButtons.map((button, index) => (
//         <React.Fragment key={button.key}>
//           <Tooltip title={button.tooltip} arrow placement="top">
//             <Box sx={getButtonStyle(button.key, selectedButton === button.key)}>
//               <IconButton
//                 size="small"
//                 onClick={() => handleButtonClick(button.key)}
//                 sx={{
//                   color: selectedButton === button.key
//                     ? colors?.warning?.[500] || '#ff9800'
//                     : colors?.primary?.[500] || '#009688',
//                   '& .MuiSvgIcon-root': { fontSize: '20px' },
//                   p: 0.75,
//                   transition: 'all 0.2s ease'
//                 }}
//               >
//                 {button.icon}
//               </IconButton>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   mt: 0.5,
//                   fontWeight: 600,
//                   fontSize: '0.75rem',
//                   color: selectedButton === button.key
//                     ? colors?.warning?.[600] || '#e68900'
//                     : colors?.grey?.[700] || '#424242',
//                   textAlign: 'center',
//                   lineHeight: 1.2,
//                   minWidth: 60
//                 }}
//               >
//                 {button.label}
//               </Typography>
//             </Box>
//           </Tooltip>
//           {index < actionButtons.length - 1 && (
//             <Divider
//               orientation="vertical"
//               flexItem
//               sx={{
//                 height: 32,
//                 mx: 0.5,
//                 borderColor: alpha(colors?.grey?.[400] || '#bdbdbd', 0.5)
//               }}
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </Paper>
//   );
// };

// export default PurchaseActionMenu;



// import {
//   Box,
//   Divider,
//   IconButton,
//   Tooltip,
//   Typography,
//   alpha
// } from "@mui/material";
// import React, { useState } from "react";

// import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
// import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
// import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
// import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
// import TimelineIcon from '@mui/icons-material/Timeline';

// const PurchaseActionMenu = ({
//   selectedButtonName,
//   setSelectedButtonName,
//   handlecallProcess,
//   selectedMode,
//   colors
// }) => {
//   const [selectedButton, setSelectedButton] = useState(null);

//   const actionButtons = [
//     { key: 'edit', label: 'Edit', icon: <ModeEditOutlineOutlinedIcon /> },
//     { key: 'Email', label: 'Mail', icon: <EmailOutlinedIcon /> },
//     { key: 'PDF', label: 'PDF', icon: <PictureAsPdfOutlinedIcon /> },
//     ...(selectedMode === 1 ? [{ key: 'Receive', label: 'Receive', icon: <ExitToAppRoundedIcon /> }] : []),
//     { key: 'Bill', label: 'Bill', icon: <ReceiptRoundedIcon /> },
//     { key: 'timeline', label: 'Timeline', icon: <TimelineIcon /> }
//   ];

//   const handleButtonClick = (buttonName) => {
//     setSelectedButton(buttonName);
//     setSelectedButtonName(buttonName);
//     handlecallProcess(buttonName);
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         gap: 0.5,
//         p: 0.75,
//         height: 44, // Compact height
//         borderRadius: 2,
//         border: `1px solid ${alpha(colors?.grey?.[300] || '#e0e0e0', 0.5)}`,
//         background: alpha(colors?.grey?.[50] || '#f5f5f5', 0.6),
//         backdropFilter: 'blur(8px)'
//       }}
//     >
//       {actionButtons.map((button, index) => (
//         <React.Fragment key={button.key}>
//           <Tooltip title={button.tooltip || button.label} arrow placement="top">
//             <IconButton
//               size="small"
//               onClick={() => handleButtonClick(button.key)}
//               sx={{
//                 p: 0.5,
//                 minWidth: 36,
//                 height: 36,
//                 borderRadius: 1.5,
//                 color: selectedButton === button.key
//                   ? colors?.warning?.[500] || '#ff9800'
//                   : colors?.primary?.[500] || '#009688',
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   backgroundColor: alpha(colors?.primary?.[500] || '#009688', 0.1),
//                   transform: 'scale(1.05)'
//                 },
//                 ...(selectedButton === button.key && {
//                   backgroundColor: alpha(colors?.warning?.[500] || '#ff9800', 0.15),
//                   boxShadow: `0 2px 8px ${alpha(colors?.warning?.[500] || '#ff9800', 0.2)}`
//                 })
//               }}
//             >
//               {button.icon}
//             </IconButton>
//           </Tooltip>
//           {index < actionButtons.length - 1 && (
//             <Divider
//               orientation="vertical"
//               flexItem
//               sx={{ height: 24, mx: 0.25, borderColor: alpha(colors?.grey?.[400] || '#bdbdbd', 0.3) }}
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </Box>
//   );
// };

// export default PurchaseActionMenu;

